import { render, staticRenderFns } from "./3d.vue?vue&type=template&id=66fd7072&scoped=true"
import script from "./3d.vue?vue&type=script&lang=js"
export * from "./3d.vue?vue&type=script&lang=js"
import style0 from "./3d.vue?vue&type=style&index=0&id=66fd7072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fd7072",
  null
  
)

export default component.exports